import { AnimationKeyframe } from 'src/lib/animationKeyframe';

export const homeAdvertAnimation = {
  contentOut: new AnimationKeyframe(0, 1000),
  backgroundOut: new AnimationKeyframe(1000, 3000),
  contentIn: new AnimationKeyframe(2000, 2000),
};
